import React from 'react';
import styles from '../Operations.module.css';

interface DAComponent extends React.FC {
  title?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

/**
 * DA - Discovery Acceptance
 * KPI information component
 */
const DA: DAComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>

      <div className={styles.sectionContent}>
        Discovery Acceptance is the % of recommended planogram SKUs that are carried by a store.
        This metric is based on the planograms the store is mapped to for all Discovery recommended categories across all departments.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>

      <div className={styles.sectionContent}>
        Each store is assigned to and measured against an active planogram for each Discovery category based on the store&apos;s format and region.<br/><br />
        This planogram mapping is constantly updated based on the store&apos;s planogram purchases in Discovery Assortment Planner.<br/><br />
        The store is considered compliant to a SKU when the SKU is on hand, or appears in the stores 1-year sales history or 3-year purchase history.
        If the SKU is actioned in Item Change Management (ICM) or Planogram Change Management (PCM) it will also be considered compliant.<br/><br />
        SKUs that are restricted or not available in the store&apos;s RSC are not counted in the calculation.
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>

      <div className={styles.sectionContent}>
        Platinum: 70%<br/>
        Pinnacle: 80%
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>

      <div>
        Click on the link in the Current Value for Discovery Acceptance to determine which departments to refresh.
        The Discovery Assortment Planner will open to the department selected allowing you to place an order.
      </div>
    </div>
  );
};

DA.title = 'Discovery Acceptance';
DA.actionTitle = 'DISCOVERY IMPACT CALCULATOR';
DA.actionHyperlink = 'dynamicURL:WFC:current';
export default DA;

